/* eslint-disable angular/factory-name */
/* global URL */

angular.
module("dx.webapp.validation").
factory("validationService", function validationService(
	$q,
	$interval,

	dxApiV1OnlineResources,
	DX_URL_ERROR
) {
	"use strict";

	// cache whether a URL was resolved to throttle the number of calls to the server
	var isUrlResolvedCache = {};
	// clear the resolved URL cache every 15 seconds
	$interval(function clearUrlCache() {
		isUrlResolvedCache = {};
	}, 15000);

	function isUrlParsable(rawUrl) {
		var url;
		try {
			url = new URL(rawUrl);
		} catch (e) {
			return false;
		}

		return url.protocol === "http:" || url.protocol === "https:";
	}

	function isUrlResolvable(rawUrl, isExternalTool) {
		return dxApiV1OnlineResources.resolve.post(rawUrl, isExternalTool).then(function onSuccess(resp) {
			return resp.data;
		});
	}

	return {
		// Verifies the email is in an acceptable format. Strict should always be used on new data.
		// Non-strict should be used for logging in, and other submissions where 'bad' data may already exist.
		// The strict email validation is comparable to what Google use for Gmail.
		// Use this validation for user generated resources like account creation and invites.
		isEmailValid: function isEmailValid(email, strict) {
			if (strict) {
				return this.isValid(email, /^[a-zA-Z0-9]+([\w-.+_']{1}[a-zA-Z0-9_'-]+)*@[a-zA-Z0-9]+([-.+_]{1}[a-zA-Z0-9]+)*\.[\w-]{2,}$/) && !email.includes("..");
			}

			return this.isValid(email, /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		},

		isStudentCodeValid: function isStudentCodeValid(studentCode) {
			return this.isValid(studentCode, /^[a-zA-Z0-9_.@-]{1,50}$/);
		},

		isNameValid: function isNameValid(name) {
			return name.length > 0 && name.length < 500;
		},

		isValid: function isValid(text, regexp) {
			if (typeof text === "undefined" || text.length === 0) {
				return false;
			}

			return regexp.test(text);
		},

		preprocessUrl: function preprocessUrl(rawUrl) {
			var res = rawUrl;
			// don't do anything with empty strings
			if (!rawUrl) {
				return res;
			}

			if (rawUrl.indexOf("http://") === -1 &&
				rawUrl.indexOf("https://") === -1) {
				res = "http://" + rawUrl;
			}

			return res;
		},

		isUrlValid: function isUrlValid(rawUrl, isExternalTool) {
			var deferred = $q.defer();
			if (!isUrlParsable(rawUrl)) {
				deferred.resolve({
					valid: false,
					error: DX_URL_ERROR.INVALID_FORMAT,
				});
				return deferred.promise;
			}

			if (isUrlResolvedCache.hasOwnProperty(rawUrl)) {
				deferred.resolve({
					valid: isUrlResolvedCache[rawUrl].ok,
					error: isUrlResolvedCache[rawUrl].error ? isUrlResolvedCache[rawUrl].error : null,
				});

				return deferred.promise;
			}

			isUrlResolvable(rawUrl, isExternalTool).then(function onSuccess(response) {
				isUrlResolvedCache[rawUrl] = {
					ok: response.ok,
					error: response.error ? response.error : null,
				};

				if (response.ok) {
					deferred.resolve({
						valid: true,
					});
				} else {
					switch (response.error) {
						case DX_URL_ERROR.NO_SUCH_HOST:
							deferred.resolve({
								valid: false,
								error: DX_URL_ERROR.NO_SUCH_HOST,
							});
							break;
						case DX_URL_ERROR.REDIRECT_TIMEOUT:
							if (isExternalTool) {
								deferred.resolve({
									valid: true,
								});
							} else {
								deferred.resolve({
									valid: false,
									error: DX_URL_ERROR.REDIRECT_TIMEOUT,
								});
							}
							break;
						default:
							deferred.resolve({
								valid: false,
								error: DX_URL_ERROR.OTHER,
							});
					}
				}
			}, function onFail() {
				deferred.reject();
			});

			return deferred.promise;
		},

		isExternalToolTitleValid: function isExternalToolTitleValid(title) {
			return title.length > 0 && title.length <= 50;
		},
	};
});
